import React from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";

import "bootstrap/dist/css/bootstrap.min.css";
import navbarStyle from "./NavbarStyle";
import './NavBar.css';

function NaviBar() {
  return (
    <Navbar style={navbarStyle} expand="lg">
      <Container>
        <Navbar.Brand href="/eng">
          <h1 className = {"brandName"} style={{fontFamily: 'Diphylleia', fontWeight:"bold"}}>Sook Choi</h1>
          <h5 className = {"brandName"} style={{fontFamily: 'Noto Sans KR'}}> <i>Steady archivist</i></h5>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto">
            <Nav.Link href="/resume-eng"><h6 className = {"menu"} >Resume</h6></Nav.Link>
            <Nav.Link href="/personality-eng"><h6 className = {"menu"} >Personality</h6></Nav.Link>
            <Nav.Link href="/project-eng"><h6 className = {"menu"} >Project & Tech</h6></Nav.Link>
            <Nav.Link  href="/award-eng"><h6 className = {"menu"} >Award & Certificate</h6></Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NaviBar;
